import AppLayout from './AppLayout.json';
import AdminLayout from './AdminLayout.json';
import Meeting from './Meeting';

export default {
  AppLayout,
  Meeting,
  AdminLayout,
};
